/**
 * Yandex.Metrika bootstrap.
 *
 * Analytics is loaded lazily and only after the visitor has accepted the
 * cookie notice (see CookieNotice.tsx). Keeping the snippet here instead of
 * index.html guarantees that no analytics request happens before consent.
 */

const metrikaCounterId = 103658141;
const metrikaScriptSrc = `https://mc.yandex.ru/metrika/tag.js?id=${metrikaCounterId}`;

type MetrikaQueue = {
  (...args: unknown[]): void;
  a?: unknown[][];
  l?: number;
};

let analyticsInitialized = false;

export function initAnalytics() {
  if (analyticsInitialized || typeof window === 'undefined') {
    return;
  }
  analyticsInitialized = true;

  const browserWindow = window as Window & { ym?: MetrikaQueue };

  if (!browserWindow.ym) {
    const queue = ((...args: unknown[]) => {
      (queue.a = queue.a || []).push(args);
    }) as MetrikaQueue;
    queue.l = Date.now();
    browserWindow.ym = queue;
  }

  if (!document.querySelector(`script[src="${metrikaScriptSrc}"]`)) {
    const script = document.createElement('script');
    script.async = true;
    script.src = metrikaScriptSrc;
    document.head.appendChild(script);
  }

  browserWindow.ym(metrikaCounterId, 'init', {
    ssr: true,
    clickmap: true,
    ecommerce: 'dataLayer',
    accurateTrackBounce: true,
    trackLinks: true,
  });
}
